import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Find all buttons within this controller's element
    this.buttons = this.element.querySelectorAll('button[type="submit"], a.btn')
  }

  disableButtons(event) {
    // Disable buttons immediately when clicked
    this.disableAllButtons()
  }

  disableAllButtons() {
    // Disable all buttons and add visual feedback
    this.buttons.forEach(button => {
      button.disabled = true
      button.classList.add('opacity-50', 'cursor-not-allowed')
      // For links, we need to prevent clicks
      if (button.tagName === 'A') {
        button.style.pointerEvents = 'none'
      }
    })
  }
} 